'use client';

import { useParams } from 'next/navigation';

import { ConfigProvider } from 'reservations/account/providers/ConfigProvider';
import WaitlistOrBookingScreen from 'reservations/availabilities/components/WaitlistOrBookingScreen';
import PageLoadSpinner from 'reservations/base/components/PageLoadSpinner';
import useIsLoading from 'reservations/base/hooks/useIsLoading';

type Params = {
  slug: string;
};

export default function LocationBySlug() {
  const params = useParams<Params>();
  const slug = params?.slug;

  const isPageLoading = useIsLoading();

  if (isPageLoading) {
    return (
      <PageLoadSpinner isLoading message="Finding first available date..." />
    );
  }

  if (!slug) {
    return <></>;
  }

  return (
    <ConfigProvider slug={slug}>
      <WaitlistOrBookingScreen slug={slug} />
    </ConfigProvider>
  );
}
